import React, { Component } from 'react';
import './SignupModal.css';
import Modal from '@material-ui/core/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCity, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import enhance from './Signup.enhancer';
import { userStatuses } from '../../../constants';
import axios from 'axios';

class SignUpModal extends Component {
  constructor() {
    super();

    this.initialState = {
      step: 1,
      companySignup: true,
      firstName: '',
      firstNameErrorText: 'First name is required',
      lastName: '',
      lastNameErrorText: 'Last name is required',
      companyName: '',
      companyNameErrorText: 'Company name is required',
      email: '',
      emailErrorText: 'Email is required',
      password: '',
      passwordErrorText: 'Password is required',
      passwordConfirmation: '',
      passwordConfirmationErrorText: 'Confirm password is required',
      submitAttempted: false,
      confirmEmailError: false,
      subscriberCountError: false,
      usernameNotFoundError: false
    };
    this.state = {
      ...this.initialState
    };
  }

  componentDidMount() {
    this.props.firebase.auth().onAuthStateChanged(user => {
      if (user && user.uid && this.state.step === 2) {
        if (this.state.companySignup) {
          this.props.history.push('/company-signup');
        } else {
          this.props.history.push('/influencer-signup');
        }
        this.setState({ ...this.initialState });
        this.props.closeSignupModal();
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.companySignup) {
      this.handleCompanyPlatformButton();
    }
    if (nextProps.influencerSignup) {
      this.handleInfluncerPlatformButton();
    }
  }

  handleCloseModal = () => {
    const gg = this.state;
    this.setState({ ...this.initialState });
    this.props.closeSignupModal();
  };

  handleCompanyPlatformButton = () => {
    this.setState({
      step: 2,
      companySignup: true
    });
  };

  handleInfluncerPlatformButton = () => {
    this.setState({
      step: 2,
      companySignup: false
    });
  };

  handleChange = e => {
    this.setState({
      [e.target.id]: e.target.value
    });
  };

  handleFirstNameChange = e => {
    this.handleChange(e);
    if (!e.target.value && !this.state.companySignup) {
      this.setState({ firstNameErrorText: 'First Name is required' });
    } else {
      this.setState({ firstNameErrorText: '' });
    }
  };

  handleLastNameChange = e => {
    this.handleChange(e);

    if (!e.target.value && !this.state.companySignup) {
      this.setState({ lastNameErrorText: 'First Name is required' });
    } else {
      this.setState({ lastNameErrorText: '' });
    }
  };

  handleCompanyNameChange = e => {
    this.handleChange(e);

    if (!e.target.value && this.state.companySignup) {
      this.setState({ companyNameErrorText: 'Company is required' });
    } else {
      this.setState({ companyNameErrorText: '' });
    }
  };

  handleEmailNameChange = e => {
    this.handleChange(e);

    if (!e.target.value) {
      this.setState({ emailErrorText: 'Email is required' });
    } else {
      this.setState({ emailErrorText: '' });
    }
  };

  handlePasswordChange = e => {
    this.handleChange(e);
    if (!e.target.value) {
      return this.setState({ passwordErrorText: 'Password is required' });
    } else if (e.target.value.length < 8) {
      return this.setState({
        passwordErrorText: 'Password must be at least 8 characters long'
      });
    } else if (
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/.test(
        e.target.value
      ) === false
    ) {
      this.setState({
        passwordErrorText:
          'Password must contain at least 1 lowercase character, 1 capital letter, 1 number and 1 special character (!@#$%^&)'
      });
    } else {
      return this.setState({ passwordErrorText: '' });
    }
    if (e.target.value !== this.state.passwordConfirmation) {
      return this.setState({
        passwordConfirmationErrorText: 'Passwords do not match'
      });
    } else {
      return this.setState({ passwordConfirmationErrorText: '' });
    }
  };

  handleConfirmPasswordChange = e => {
    this.handleChange(e);

    if (!e.target.value) {
      this.setState({
        passwordConfirmationErrorText: 'Password confirm is required'
      });
    } else if (this.state.password !== e.target.value) {
      this.setState({
        passwordConfirmationErrorText: 'Passwords do not match'
      });
    } else {
      this.setState({ passwordConfirmationErrorText: '' });
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ submitAttempted: true });
    if (this.formIsValid()) {
      this.props.signUp(this.state);
    }
  };

  formIsValid() {
    return (
      (this.state.companySignup || !this.state.firstNameErrorText) &&
      (this.state.companySignup || !this.state.lastNameErrorText) &&
      !this.state.emailErrorText &&
      !this.state.passwordErrorText &&
      !this.state.passwordConfirmationErrorText &&
      (!this.state.companySignup || !this.state.companyNameErrorText)
    );
  }

  youtubeApiComplete = response => {
    if (response)
      if (response.success) {
        this.setState({
          subscriberCountError: false,
          usernameNotFoundError: false
        });
      } else {
        if (response.error === 'subscriberCount') {
          this.setState({
            subscriberCountError: true
          });
        } else if (response.error === 'usernameNotFound') {
          this.setState({
            usernameNotFoundError: true
          });
        }
      }
  };

  tryYoutubeApi() {
    this.setState({ submitAttempted: true });
    if (!this.state.firstNameErrorText && !this.state.lastNameErrorText) {
      window.gapi.load('client:auth2', () => {
        this.props.signInWithYoutube(
          this.state.firstName,
          this.state.lastName,
          this.youtubeApiComplete
        );
      });
    }
  }

  render() {
    const { classes, authError, profile, firebase } = this.props;
    const { usernameNotFoundError, subscriberCountError } = this.state;

    let bottomContent;
    let topHeader;

    // set bottom content based on the step the user is on
    if (this.state.step === 1) {
      topHeader = "Select the platform that's right for you.";
      bottomContent = (
        <div className="sign-up-bottom">
          <div className="platform-button-container">
            <div
              className="platform-select-button"
              onClick={this.handleInfluncerPlatformButton}
            >
              <div className="medium-header-text">I'm an influencer</div>
              <div className="platform-icon-container">
                <FontAwesomeIcon className="" icon={faThumbsUp} />
              </div>
            </div>
          </div>
          <div className="platform-button-container">
            <div
              className="platform-select-button"
              onClick={this.handleCompanyPlatformButton}
            >
              <div className="medium-header-text">I'm a company</div>
              <div className="platform-icon-container">
                <FontAwesomeIcon className="" icon={faCity} />
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      topHeader = 'Create your account';
      bottomContent = (
        <div className="sign-up-bottom">
          <Typography variant="h6" gutterBottom />
          <Grid container spacing={3} className="info-container">
            {!this.state.companySignup && (
              <Grid item xs={12} sm={12}>
                <TextField
                  required
                  id="firstName"
                  variant="outlined"
                  name="firstName"
                  label="First name"
                  value={this.state.firstName}
                  onChange={this.handleFirstNameChange}
                  error={
                    this.state.submitAttempted && this.state.firstNameErrorText
                      ? true
                      : false
                  }
                  helperText={
                    this.state.submitAttempted
                      ? this.state.firstNameErrorText
                      : ''
                  }
                  fullWidth
                />
              </Grid>
            )}
            {!this.state.companySignup && (
              <Grid item xs={12} sm={12}>
                <TextField
                  required
                  variant="outlined"
                  id="lastName"
                  name="lastName"
                  label="Last name"
                  value={this.state.lastName}
                  onChange={this.handleLastNameChange}
                  error={
                    this.state.submitAttempted && this.state.lastNameErrorText
                      ? true
                      : false
                  }
                  helperText={
                    this.state.submitAttempted
                      ? this.state.lastNameErrorText
                      : ''
                  }
                  fullWidth
                  autoComplete="lname"
                />
              </Grid>
            )}
            {this.state.companySignup && (
              <React.Fragment>
                <Grid item xs={12} align="center" justify="center">
                  <TextField
                    required
                    variant="outlined"
                    id="companyName"
                    name="companyName"
                    label="Company Name"
                    value={this.state.companyName}
                    onChange={this.handleCompanyNameChange}
                    error={
                      this.state.submitAttempted &&
                      this.state.companyNameErrorText
                        ? true
                        : false
                    }
                    helperText={
                      this.state.submitAttempted
                        ? this.state.companyNameErrorText
                        : ''
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    variant="outlined"
                    id="email"
                    name="email"
                    label="Email"
                    value={this.state.email}
                    onChange={this.handleEmailNameChange}
                    error={
                      this.state.submitAttempted && this.state.emailErrorText
                        ? true
                        : false
                    }
                    helperText={
                      this.state.submitAttempted
                        ? this.state.emailErrorText
                        : ''
                    }
                    type="email"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    variant="outlined"
                    id="password"
                    name="password"
                    label="Password"
                    type="password"
                    value={this.state.password}
                    onChange={this.handlePasswordChange.bind(this)}
                    error={
                      this.state.submitAttempted && this.state.passwordErrorText
                        ? true
                        : false
                    }
                    helperText={
                      this.state.submitAttempted
                        ? this.state.passwordErrorText
                        : ''
                    }
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    variant="outlined"
                    id="passwordConfirmation"
                    name="passwordConfirmation"
                    label="Confirm Password"
                    type="password"
                    value={this.state.passwordConfirmation}
                    onChange={this.handleConfirmPasswordChange.bind(this)}
                    error={
                      this.state.submitAttempted &&
                      this.state.passwordConfirmationErrorText
                        ? true
                        : false
                    }
                    helperText={
                      this.state.submitAttempted
                        ? this.state.passwordConfirmationErrorText
                        : ''
                    }
                    fullWidth
                  />
                </Grid>
              </React.Fragment>
            )}
            <Grid item xs={12}>
              <div className="auth-error">{authError}</div>
              {usernameNotFoundError && (
                <div className="auth-error">
                  Your username was not found. Check that you entered it
                  correctly
                </div>
              )}
              {subscriberCountError && (
                <div className="auth-error">
                  Must have at least 100 subscribers to join platform
                </div>
              )}
              {!this.state.companySignup && (
                // <button onClick={this.tryYoutubeApi.bind(this)}>execute</button>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.submitButton}
                  onClick={this.tryYoutubeApi.bind(this)}
                >
                  Sign Up with Youtube
                </Button>
              )}
              {this.state.companySignup && (
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.submitButton}
                  onClick={this.handleSubmit}
                >
                  Create Account
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
      );
    }
    return (
      <Modal
        open={this.props.showModal}
        onClose={this.props.handleClose}
        className={classes.modalStyles}
        disableAutoFocus={true}
        onBackdropClick={this.handleCloseModal.bind(this)}
      >
        <div className="signup-modal">
          {this.props.processingSignup && (
            <CircularProgress className={classes.loadingSpinner} />
          )}
          <div className="sign-up-container">
            <div className="sign-up-top">
              <div className="logo-container">
                <img className="hype-pilot-logo" src="/images/hplogo.png" />
              </div>
              <div className="medium-header-text">{topHeader}</div>
            </div>
            {bottomContent}
          </div>
        </div>
      </Modal>
    );
  }
}

SignUpModal.propTypes = {
  router: PropTypes.object,
  profile: PropTypes.object,
  firebase: PropTypes.object
};

export default enhance(SignUpModal);



// WEBPACK FOOTER //
// ./src/components/shared/signUpModal/SignupModal.js